import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { IoMdArrowDropright } from "react-icons/io";
import banner3 from "../assets/banner3.jpg"; 

export default function HomeBanner2() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return (
      <div className="container d-flex justify-content-center align-items-center" style={{ height: "500px" }}>
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <section
      className="MainBodySection position-relative overflow-hidden"
      style={{
        minHeight: "650px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: `url(${banner3})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Dark gradient overlay — more refined than solid tint */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: "linear-gradient(120deg, rgba(0,0,0,0.6) 0%, rgba(0,20,40,0.8) 100%)",
        }}
      />

      <div className="container position-relative">
        <div className="row justify-content-center text-center text-lg-start">
          <div className="col-12 col-lg-10 col-xl-8">
            {/* Tagline — primary emphasis */}
            <h5
              className="text-light font-bold mb-3"
              style={{
                fontSize: "1rem",
                letterSpacing: "2px",
                textTransform: "uppercase",
                opacity: 0.9,
              }}
              data-aos="fade-up"
              data-aos-delay="100"
            >
              Tech-First. Future-Focused. Africa-Built.
            </h5>

            {/* Main headline */}
            <h1
              className="text-primary font-bold mb-4"
              style={{
                fontSize: "48px",
                lineHeight: 1.2,
                letterSpacing: "-0.5px",
                textShadow: "0 2px 8px rgba(0,0,0,0.3)",
              }}
              data-aos="fade-up"
              data-aos-delay="200"
            >
              Ndomano Group of Companies
            </h1>

            {/* Subheading — concise & mission-driven */}
            <p
              className="text-light mb-5"
              style={{
                fontSize: "1.25rem",
                margin: "0 auto",
              }}
              data-aos="fade-up"
              data-aos-delay="300"
            >
              A next-generation African conglomerate unifying finance, mobility, logistics, pharmaceuticals, and technology — all engineered to transform lives and business across Tanzania and beyond.
            </p>

            {/* Dual CTA (primary + secondary) */}
            <div
              className="d-flex flex-column flex-sm-row justify-content-center gap-3 mb-4"
              data-aos="zoom-in"
              data-aos-delay="400"
            >
              <button
                className="px-5 py-3 rounded-pill border-0 font-bold d-flex align-items-center justify-content-center gap-2 mt-3"
                style={{
                  background: "linear-gradient(90deg, #00356d, #0055a4)",
                  color: "#fff",
                  fontSize: "1.05rem",
                  boxShadow: "0 8px 20px rgba(0, 53, 109, 0.4)",
                  transition: "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
                }}
                onClick={() => appContext.navTo({ item: "about_us" })}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-4px) scale(1.03)";
                  e.currentTarget.style.boxShadow = "0 12px 30px rgba(0, 53, 109, 0.6)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0) scale(1)";
                  e.currentTarget.style.boxShadow = "0 8px 20px rgba(0, 53, 109, 0.4)";
                }}
              >
                Discover Our Vision
                <IoMdArrowDropright size={24} />
              </button>

              <button
                className="px-5 py-3 rounded-pill border fw-bold d-flex align-items-center justify-content-center gap-2"
                style={{
                  borderColor: "rgba(255,255,255,0.4)",
                  color: "#fff",
                  background: "transparent",
                  fontSize: "1.05rem",
                  transition: "all 0.3s ease",
                }}
                onClick={() => appContext.navTo({ item: "subsidiaries" })}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "rgba(255,255,255,0.1)";
                  e.currentTarget.style.transform = "translateY(-2px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "transparent";
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                Explore Subsidiaries
              </button>
            </div>

            {/* Floating badge — subtle brand reinforcement */}
            
          </div>
        </div>
      </div>
    </section>
  );
}